import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconChevronLeft,
	homefieldIconChevronRight
} from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProTipsComponent } from './pro-tips.component';
import { ResizeDeviceBreakPointDirective } from '@shared/utils/directives';
import { WindowModule } from '@shared/utils/services';

@NgModule({
	declarations: [ProTipsComponent],
	imports: [
		CommonModule,
		HomefieldIconLibraryModule,
		WindowModule
	],
	providers: [ResizeDeviceBreakPointDirective],
	exports: [ProTipsComponent]
})
export class ProTipsModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconChevronLeft,
			homefieldIconChevronRight
		]);
	}
}
